import { render, staticRenderFns } from "./VectorWidget.vue?vue&type=template&id=20775eb7&scoped=true&"
import script from "./VectorWidget.vue?vue&type=script&lang=js&"
export * from "./VectorWidget.vue?vue&type=script&lang=js&"
import style0 from "./VectorWidget.vue?vue&type=style&index=0&id=20775eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20775eb7",
  null
  
)

export default component.exports